import * as React from "react";
import { Loader } from "semantic-ui-react";
import { firebaseDB } from "../firebase";
import { Quad } from "../types";

const { Provider, Consumer } = React.createContext<IState>({
	isLoading: false,
	quadrants: {}
});

interface IState {
	isLoading: boolean;
	quadrants: {
		[id: string]: Quad;
	};
}

interface IProps {}

class QuadrantProvider extends React.Component<IProps, IState> {
	state = {
		isLoading: true,
		quadrants: {}
	};

	componentDidMount() {
		this.setState({ isLoading: true });
		const ref = firebaseDB.ref("quadrants");
		ref.on(
			"value",
			snapshot => {
				console.log(snapshot.val());
				this.setState(
					{
						isLoading: false,
						quadrants: {
							...this.state.quadrants,
							...snapshot.val()
						}
					},
					() => console.log(this.state)
				);
			},
			err => {
				throw err;
			}
		);
	}

	static Consumer = Consumer;

	render() {
		return <Provider value={this.state}>{this.props.children}</Provider>;
	}
}

export default QuadrantProvider;

export interface QuadrantProps {
	quadrants: IState["quadrants"];
	isLoaded: boolean;
}

export function withQuadrants(Component) {
	return function WithLoggedInRedirect(props) {
		return (
			<Consumer>
				{data => (
					<Component
						{...props}
						isLoaded={!data.isLoading}
						quadrants={data.quadrants}
					/>
				)}
			</Consumer>
		);
	};
}

export function syncWithQuadrants(Component) {
	return function WithLoggedInRedirect(props) {
		return (
			<Consumer>
				{data =>
					data.isLoading ? (
						<Loader active />
					) : (
						<Component {...props} quadrants={data.quadrants} />
					)
				}
			</Consumer>
		);
	};
}



// WEBPACK FOOTER //
// ./src/helpers/QuadrantProvider.tsx